import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';
import { useMemo } from 'react';

export type ProductRatingPropsMapSettings = boolean;

export const useConnectProductRating = (place: 'img' | 'info') => {
  const settings = useProductItemThemeSettings();

  const productElmSettings =
    place === 'img' ? settings.productImg.elements : settings.productInfo?.elements;

  const props: ProductRatingPropsMapSettings = useMemo(() => {
    return !!productElmSettings?.rating;
  }, [productElmSettings]);

  return {
    props,
  };
};
